import React, { createContext, useState, useContext } from "react";

type Lang = "es" | "en";

interface LangContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (es: string, en: string) => string;
}

const LangContext = createContext<LangContextType>({
  lang: "es",
  setLang: () => {},
  t: (es) => es,
});

export const useLang = () => useContext(LangContext);

const LangProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Lang>(() => {
    const saved = localStorage.getItem("foo_lang");
    return saved === "en" ? "en" : "es";
  });

  const changeLang = (newLang: Lang) => {
    setLang(newLang);
    localStorage.setItem("foo_lang", newLang);
  };

  const t = (es: string, en: string) => (lang === "es" ? es : en);

  return (
    <LangContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export default LangProvider;
